const InputInlineAddon = ({
  label,
  prefix = "https://",
  mobilePrefix = null,
  placeholder,
  name,
  id,
  register,
  error,
  ...inputProps
}) => {
  return (
    <div>
      {label && (
        <label
          htmlFor={id || name}
          className="block text-sm/6 font-medium text-ink-700"
        >
          {label}
        </label>
      )}
      <div className="mt-2">
        <div className="flex items-center rounded-card bg-white pl-3 border border-ink-200 focus-within:border-accent-500 focus-within:ring-2 focus-within:ring-accent-500/20 transition-colors">
          <div className="shrink-0 select-none text-base text-ink-500 sm:text-sm/6">
            {mobilePrefix ? (
              <>
                <span className="hidden sm:inline">{prefix}</span>
                <span className="sm:hidden">{mobilePrefix}</span>
              </>
            ) : (
              prefix
            )}
          </div>
          <input
            id={id || name}
            name={name}
            type="text"
            placeholder={placeholder}
            autoCapitalize="none"
            autoCorrect="off"
            autoComplete="off"
            spellCheck="false"
            inputMode="url"
            className="block min-w-0 grow border-0 bg-transparent py-2 pl-1 pr-3 text-sm text-ink-900 placeholder:text-ink-400 focus:outline-none focus:ring-0 sm:text-sm/6"
            {...(register && register(name))}
            {...inputProps}
          />
        </div>
      </div>
      {error && <p className="mt-2 text-sm text-signal-red-700">{error}</p>}
    </div>
  );
};

export default InputInlineAddon;
